module.exports = __webpack_public_path__ + "static/media/coming-soon-bg.fd917163.svg";